import { type ReactNode } from "react";
import clsx from "clsx";
import { StatusDeclinedIcon } from "@/shared/assets/svg/icons";
import { fallbackString } from "@/shared/utils";
import type { components } from "@entities/journal";



type Signer = components["schemas"]["SignerInfo"];

export const RejectedSign = ({ children, signer }: { children: ReactNode, signer: Signer | undefined }) => {
    return (
      <div className="table-block">
        <div
          className={clsx("table-container table-container-signature", {
            [`table-container-signature-rejected`]: "rejected",
          })}
        >
          {children}
          <div className="represented-container rejected">
            <div className="flex-between represented-status-row">
              <div className="flex-default">
                <div className="represented-icon-container rejected">
                  <StatusDeclinedIcon />
                </div>
                Отклонено подписание
              </div>
              <div>
              {signer?.updateDate
                  ? new Date(signer.updateDate).toLocaleString("ru-RU", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : ""}
  
  
              </div>
            </div>
            <p>{fallbackString(signer?.comment)}</p>
            {/* когда-то это понадобится (после мчд я так понимаю) */}
            {/* <div style={{ fontSize: 12, marginBottom: 8 }}>
              Доверенность № 123-32b-1w1e-77er
            </div>
            <div style={{ fontSize: 12 }}>с 11.07.2024 по 11.07.2025</div> */}
          </div>
        </div>
      </div>
    );
  };
